<template>
<div>
     <div class="px-6 md:pr-0 md:pl-20">
        <h1 class="pt-12 text-4xl text-gray-900 xl:text-6xl 2xl:text-10xl md:pt-20 xl:pt-20 md:text-5xl ">Chata pod</h1>
        <h2 class="text-3xl text-gray-800 md:text-3xl xl:text-4xl">Luhačovickou přehradou</h2>
        <p class="pt-6 pb-12 text-xl text-gray-700 md:text-xl">Prozkoumejte krásy lázní Luhačovice a přilehlého<br>okolí v útulné chatě s obrovskou zahradou.</p>
        <div class="flex justify-center md:block">
            <Link href="/rezervace" class="px-12 py-2 text-2xl text-white rounded cursor-pointer bg-chred hover:bg-chreddark">
                Rezervace
            </Link>
        </div>
    </div>

    <img class="absolute top-0 right-0 landing-image" src="/img/chata-landing.png" alt="Chata pod Luhačovickou přehradou">
</div>
</template>

<script>

import { Link } from '@inertiajs/inertia-vue3'

  export default {

    components: {
      Link
    }
  }
</script>